export default __webpack_public_path__ + "static/media/chademo-icon.fafade52.png";